import type { FC } from 'react';
import { Modal } from '@interstate/components/Modal';
import { Typography } from '@interstate/components/Typography';

interface DeskingSaveErrorsModalProps {
    show: boolean;
    onClose: () => void;
}

const TITLE = 'Unable to Save';
const MESSAGE = 'Please resolve all highlighted errors before saving. Fields marked in red need attention.';

export const DeskingSaveErrorsModal: FC<DeskingSaveErrorsModalProps> = ({ show, onClose }) => {
    return (
        <Modal
            size="small"
            id="desking-save-errors-modal"
            data-testid="desking-save-errors-modal"
            show={show}
            onHide={onClose}
            header={
                <Typography variant="h4" color="base.color.blue.700">
                    {TITLE}
                </Typography>
            }
            footer={{
                layout: 'rightAligned',
                primary: {
                    action: onClose,
                    label: 'Review Errors',
                    customIdentifiers: {
                        primaryButton: {
                            dataTestId: 'desking-save-errors-review-btn'
                        }
                    }
                }
            }}
        >
            <Typography variant="body-md" tag="span">
                {MESSAGE}
            </Typography>
        </Modal>
    );
};
